var _a, _b;
export var CommissionStatusCodes;
(function (CommissionStatusCodes) {
    CommissionStatusCodes[CommissionStatusCodes["STATUS_DELETED"] = -2] = "STATUS_DELETED";
    CommissionStatusCodes[CommissionStatusCodes["STATUS_CREATED"] = -1] = "STATUS_CREATED";
    CommissionStatusCodes[CommissionStatusCodes["STATUS_ACTIVE"] = 1] = "STATUS_ACTIVE";
})(CommissionStatusCodes || (CommissionStatusCodes = {}));
export var CommissionStatusType;
(function (CommissionStatusType) {
    CommissionStatusType["ACTIVE"] = "active";
    CommissionStatusType["DISABLED"] = "disabled";
})(CommissionStatusType || (CommissionStatusType = {}));
export var CommissionStatusCodeMap = (_a = {},
    _a[CommissionStatusType.ACTIVE] = CommissionStatusCodes.STATUS_ACTIVE,
    _a[CommissionStatusType.DISABLED] = CommissionStatusCodes.STATUS_CREATED,
    _a);
export var CommissionStatusMap = (_b = {},
    _b[CommissionStatusCodes.STATUS_ACTIVE] = CommissionStatusType.ACTIVE,
    _b[CommissionStatusCodes.STATUS_CREATED] = CommissionStatusType.DISABLED,
    _b);
//# sourceMappingURL=commissions.js.map